module.exports = __webpack_public_path__ + "static/002-bab30726ebb4b18156092074a0ac87f4.png";